import React from 'react';
import './HealthTwoPromotions.scss';

const promotions = [
  {
    title: "Maternal Health and Comfort",
    offer: "5% Cashback",
    bgColor: "#ffe1cc",
    img: "/assets/img/health/healthTwo/oooo-removebg-preview.png"
  },
  {
    title: "Headache and Migraine Solutions",
    offer: "10% Off",
    bgColor: "#c5f1f9",
    img: "/assets/img/health/healthTwo/images-removebg-preview.png"
  },
  {
    title: "Cold and Flu Relief",
    offer: "10% Off",
    bgColor: "#fff3b0",
    img: "/assets/img/health/healthTwo/cough-removebg-preview.png"
  }
];

const HealthTwoPromotions = () => {
  return (
    <div className="health-two-promo-section">
      {promotions.map((item, i) => (
        <div
          key={i}
          className="promo-card"
          style={{ backgroundColor: item.bgColor }}
        >
          <div className="text">
            <h4>{item.title}</h4>
            <a href="link">BROWSE ALL →</a>
          </div>
          <span className="offer">{item.offer}</span>
          <img src={item.img} alt={item.title} />
        </div>
      ))}
    </div>
  );
};

export default HealthTwoPromotions; 